import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      cacheList: ['invoiceApply', 'receiptSign'],
      title: Vue.$config.projectName,
      urlQuery: {},
      showPageTab: false,
      pageHeader: Vue.$config.pageHeader,
      visible: true,
      userId: null,
      respList: [],
      flexScreenStyle:
        location.port == '8878'
          ? { width: '100%', 'box-sizing': 'border-box', 'padding-left': '40px', 'padding-right': '40px' }
          : {}
    };
  },
  computed: {
    ...mapGetters('log', ['currentMenus', 'menuList', 'activeSubMenu', 'primaryMenus', 'collectionList']),
    ...mapState('log', ['sideStatus', 'menuList', 'bageObj']),
    ...mapGetters('user', ['version', 'tipsCount']),
    ...mapState('user', ['account']),
    breadcrumb() {
      if (this.$route.query.breadcrumb) {
        return JSON.parse(this.$route.query.breadcrumb);
      }
      return null;
    },
    isSubApp() {
      return window.__MICRO_APP_ENVIRONMENT__;
    }
  },
  watch: {
    '$route.query.keepAlive'() {
      const keepAlive = this.$route.query.keepAlive;
      if (!keepAlive || keepAlive === 'false') {
        // this.$nextTick(res => {
        //     this.reload();
        // })
        this.reload();
      }
    }
  },
  created() {
    this.userId = localStorage.getItem('userId');
    this.respList = JSON.parse(localStorage.getItem('respList'));
    console.log(this.userId, this.respList);
  },
  mounted() {
   
    const scrollDom = document.querySelector('.app-main');
    if(scrollDom){
      scrollDom.addEventListener('scroll', this.scrollFunc);
    }
    /* function scrollFunction() {
        console.log(document.body.scrollTop, document.documentElement.scrollTop);
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            document.getElementById("backtop").style.display = "block";
        } else {
            document.getElementById("backtop").style.display = "none";
        }
        }
        window.onscroll = function() {scrollFunction()}; */
  },

  beforeDestroy() {
    const scrollDom = document.querySelector('.app-main');
    if(scrollDom){
      scrollDom.removeEventListener('scroll', this.scrollFunc);
    }
  },
  methods: {
    ...mapMutations('log', ['setActiveSubMenu', 'setTopCurrentMenus', 'setCurrentMenus']),
    reload() {
      this.visible = false;
      this.$route.query.keepAlive = false;
      this.$nextTick(() => {
        if (document.getElementsByClassName('app-main')[0]) {
          document.getElementsByClassName('app-main')[0].scrollTop = 0;
        }
        this.visible = true;
      });
    },
    clickBreadcrumb(item) {
      if (item.name && item.name.trim()) {
        this.$router.push(item.name);
        let menu = this.menuList.find((it) => it.name === item.name);
        this.setActiveSubMenu(menu.id);
      }
    },
    scrollFunc(event) {
      if (event.target.scrollTop > 50) {
        document.querySelector('#backtop').style.display = 'block';
      } else {
        document.querySelector('#backtop').style.display = 'none';
      }
    }
  }
};
